export const AppliedToTypes = {
  ALL_OPENINGS: 'all_openings',
  SELECTED_LOCATIONS: 'selected_locations',
} as const;

export type AppliedToType =
  (typeof AppliedToTypes)[keyof typeof AppliedToTypes];
